import * as palette from "@govlaunch/palette";
import { FormattedMessage } from "react-intl";
import BalanceTransactions from "~/components/makers/BalanceTransactions";
import useIntlDate from "~/lib/hooks/useIntlDate";
import { ICompanyAccountBillingInfoQuery } from "~/lib/queries/__generated__/CompanyAccountBillingInfoQuery.generated";

interface ICurrentBillingCurrentCreditsProps {
  balanceTransactions: NonNullable<ICompanyAccountBillingInfoQuery["company"]>["balanceTransactions"];
  canEarnCreditsUntil: NonNullable<ICompanyAccountBillingInfoQuery["company"]>["canEarnCreditsUntil"];
}

export default function CurrentBillingCurrentCredits({
  balanceTransactions,
  canEarnCreditsUntil,
}: ICurrentBillingCurrentCreditsProps) {
  const intlDate = useIntlDate();

  return (
    <>
      <div
        css={{
          fontSize: 16,
          fontWeight: 600,
          color: "#949195",
        }}
      >
        <FormattedMessage defaultMessage="Current Credits" id="dgdiG9" />
      </div>

      <div
        css={{
          display: "grid",
          gridRowGap: 10,
        }}
      >
        <div
          css={{
            display: "grid",
            gridTemplateColumns: "repeat(2, max-content)",
            gridColumnGap: 6,
          }}
        >
          <BalanceTransactions transactions={balanceTransactions}>
            {(toggleOpen) => (
              <button
                type="button"
                onClick={toggleOpen}
                css={{
                  margin: 0,
                  padding: 0,
                  textDecoration: "underline",
                  backgroundColor: "transparent",
                  border: "none",
                  outline: "none",
                  cursor: "pointer",
                  fontSize: 16,
                  fontWeight: 600,
                  color: palette.innovatorBlue,
                }}
              >
                {formatDollarAmount(balanceTransactions.length > 0 ? balanceTransactions[0].endingBalance : 0)}
              </button>
            )}
          </BalanceTransactions>
        </div>

        {canEarnCreditsUntil && (
          <div>
            <span
              css={{
                fontSize: 13,
                color: "#797979",
              }}
            >
              <FormattedMessage
                defaultMessage="Credits can be earned until {date}"
                id="BL91Tr"
                values={{
                  date: intlDate.format(canEarnCreditsUntil),
                }}
              />
            </span>
          </div>
        )}

        <div>
          <span
            css={{
              fontSize: 13,
              color: "#797979",
            }}
          >
            <FormattedMessage defaultMessage="Credit will automatically be applied to next bill" id="MQolnx" />
          </span>
        </div>
      </div>
    </>
  );
}

function formatDollarAmount(amount: number) {
  if (amount > 0) {
    return `-$${Math.abs(amount / 100).toFixed(2)}`;
  }

  return `$${Math.abs(amount / 100).toFixed(2)}`;
}
